"use strict";
import { Token } from "@uniswap/sdk-core";
import { getTokenNameOverride, getTokenSymbolOverride } from "components/CurrencyInputPanel/utils";
import { nativeOnChain } from "constants/tokens";
export const FLOW_CHAIN_ID = 747;
export const FLOW_TESTNET_CHAIN_ID = 545;
const NATIVE_TOKEN_ADDRESS = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
export const MOCK_TOKENS = {
  [FLOW_CHAIN_ID]: [
    {
      address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
      name: "Flow",
      coinKey: "FLOW",
      symbol: "FLOW",
      decimals: 18,
      icon: "",
      chainId: FLOW_CHAIN_ID
    }
  ]
};
export function mockTokenToToken(mockToken) {
  if (mockToken.address.toLowerCase() === NATIVE_TOKEN_ADDRESS.toLowerCase()) {
    return nativeOnChain(mockToken.chainId);
  }
  const symbol = getTokenSymbolOverride(mockToken.address, mockToken.symbol);
  const name = getTokenNameOverride(mockToken.address, mockToken.name);
  return new Token(mockToken.chainId, mockToken.address, mockToken.decimals, symbol, name);
}
export function getMockTokensForChain(chainId) {
  return MOCK_TOKENS[chainId] || [];
}
export function getMockTokenResult(chainId) {
  const tokens = getMockTokensForChain(chainId);
  return {
    result: {
      [chainId]: tokens
    }
  };
}
